var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33341 15C2.87508 15 2.48286 14.8532 2.15675 14.5597C1.83008 14.2657 1.66675 13.9125 1.66675 13.5V4.5C1.66675 4.0875 1.83008 3.7345 2.15675 3.441C2.48286 3.147 2.87508 3 3.33341 3H16.6667C17.1251 3 17.5176 3.147 17.8442 3.441C18.1704 3.7345 18.3334 4.0875 18.3334 4.5V13.5C18.3334 13.9125 18.1704 14.2657 17.8442 14.5597C17.5176 14.8532 17.1251 15 16.6667 15H3.33341ZM10.0001 9.61875C10.0695 9.61875 10.1423 9.60925 10.2184 9.59025C10.2951 9.57175 10.3681 9.54375 10.4376 9.50625L16.3334 6.1875C16.4445 6.125 16.5279 6.047 16.5834 5.9535C16.639 5.8595 16.6667 5.75625 16.6667 5.64375C16.6667 5.39375 16.5487 5.20625 16.3126 5.08125C16.0765 4.95625 15.8334 4.9625 15.5834 5.1L10.0001 8.25L4.41675 5.1C4.16675 4.9625 3.92369 4.95925 3.68758 5.09025C3.45147 5.22175 3.33341 5.40625 3.33341 5.64375C3.33341 5.76875 3.36119 5.878 3.41675 5.9715C3.4723 6.0655 3.55564 6.1375 3.66675 6.1875L9.56258 9.50625C9.63202 9.54375 9.70508 9.57175 9.78175 9.59025C9.85786 9.60925 9.93064 9.61875 10.0001 9.61875Z",
    fill: "#E4441C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon_mail.6fccf76237b52338b4d8f0ea1d536354.svg";
export { ForwardRef as ReactComponent };